export const MESSAGE_TYPES = {
    GENERAL: 1,
    BIOMETRIC: 2,
    ALL: null
}

export type MESSAGE_TYPE = typeof MESSAGE_TYPES[keyof typeof MESSAGE_TYPES];